import React from "react";
import { useTranslation } from "react-i18next";

function Header() {
  const { t } = useTranslation("homepage");
  const sliderData = t("header.slider", { returnObjects: true });
//irina
//irina 2
  return (
    <header className="tc-header-style1">
      <div className="header-slider">
        <div className="swiper-wrapper">
          {sliderData.map((item, i) => (
            <div key={i} className="swiper-slide">
              <div className="slider-card">
                <div className="img">
                  <img
                    src={`/home1/assets/img/slider/${i + 1}.jpg`}
                    alt=""
                    className="img-cover"
                  />
                </div>
                <div className="slider-overlay" style={{ opacity: 0.6 }}></div>
                <div className="slider-content">
                  <div className="container">
                    <div className="row justify-content-center">
                      <div className="col-lg-8 text-center">
                        {item.hideTitle ? (
                          <h1 className="main-title" style={{ fontFamily: "Montserrat, sans-serif" }}>
                            {item.subTitle}
                          </h1>
                        ) : item.title.toLowerCase() === "oneart" ? (
                          <h1 className="main-title" style={{ fontFamily: "Montserrat, sans-serif" }}>
                            ONEART
                          </h1>
                        ) : (
                          <h1 className="main-title" style={{ fontFamily: "Montserrat" }}>
                            {item.title}
                          </h1>
                        )}
                        
                        {!item.hideTitle && <h2 className="subtitle">{item.subTitle}</h2>}
                        
                        {/* <p className="description">
                          {item.desc
                            .split(/(oneart)/i)
                            .map((part, index) =>
                              part.toLowerCase() === "oneart" ? (
                                <span
                                  key={index}
                                  style={{
                                    fontFamily: "Montserrat, sans-serif",
                                    textTransform: "uppercase",
                                  }}
                                >
                                  {part}
                                </span>
                              ) : (
                                part
                              )
                            )}
                        </p> */}

                        <a
                          href={item.buttonLink || "/innerpages/portfolio"}
                          className="cta-button"
                        >
                          <span>
                            {item.button}
                            <i className="small ms-2 ti-arrow-top-right"></i>
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="slider-controls">
          <div className="swiper-button-prev"></div>
          <div className="swiper-button-next"></div>
        </div>
        <div className="swiper-pagination"></div>
      </div>
    </header>
  );
}

export default Header;
